import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as Types from 'types'
import { selectors as globalSelectors } from 'global-reducer'
import { selectors as globalArtistSelectors } from 'artist-portal-reducer'
import { Spinner } from 'lp-components'
import { SectionBlock, PortalHeader, ProfileCompletionBar } from 'components'
import { ARTIST_PORTAL_ROUTE } from 'config'
import { useCommunity } from 'utils'
import { buildBarModel } from './profile-completion-sections'

const propTypes = {
  children: PropTypes.node,
  activeSchoolYears: PropTypes.arrayOf(Types.schoolYear),
  currentSchoolYear: Types.schoolYear.isRequired,
  artist: Types.artist,
}

const defaultProps = {
  children: null,
  activeSchoolYears: null,
  artist: null,
}

function Layout({ children, activeSchoolYears, currentSchoolYear, artist }) {
  const [, setBarVersion] = useState(0)

  useEffect(() => {
    const onProfileCompletionUpdated = () => {
      setBarVersion((prev) => prev + 1)
    }
    if (typeof window !== 'undefined') {
      window.addEventListener(
        'artist-profile-completion-updated',
        onProfileCompletionUpdated
      )
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener(
          'artist-profile-completion-updated',
          onProfileCompletionUpdated
        )
      }
    }
  }, [])

  const {
    defaultBranding: { dashboardHeader },
    teachingArtistProfileCompletionEnabled,
  } = useCommunity()

  const links = [
    {
      name: 'Account Details',
      path: ARTIST_PORTAL_ROUTE + '/profile/account',
    },
    {
      name: 'Experience & Skills',
      path: ARTIST_PORTAL_ROUTE + '/profile/experience-skills',
    },
    {
      name: 'Program Delivery',
      path: ARTIST_PORTAL_ROUTE + '/profile/program-delivery',
    },
  ]

  const hasLoaded = !!activeSchoolYears
  const showBar = teachingArtistProfileCompletionEnabled && artist
  const barModel = showBar ? buildBarModel(artist) : null

  return (
    <div>
      <PortalHeader
        title={`${currentSchoolYear.number} artlook Map Profile`}
        backgroundImage={dashboardHeader}
        links={links}
      />
      <div className="content-block-container">
        {showBar && (
          <SectionBlock>
            <ProfileCompletionBar
              variant="tab-header"
              percent={barModel.percent}
              completedSections={barModel.completedSections}
              sections={barModel.sections}
            />
          </SectionBlock>
        )}
        {!hasLoaded ? <Spinner /> : <React.Fragment>{children}</React.Fragment>}
      </div>
    </div>
  )
}

Layout.propTypes = propTypes
Layout.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    activeSchoolYears: globalArtistSelectors.orderedActiveSchoolYears(state),
    currentSchoolYear: globalSelectors.currentSchoolYear(state),
    artist: globalArtistSelectors.artist(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Layout)
